var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15C9.375 15 15 9.375 15 3.75C15 9.375 20.625 15 26.25 15C20.625 15 15 20.625 15 26.25C15 20.625 9.375 15 3.75 15ZM2.5 24.375C3.54125 24.375 5.625 22.2913 5.625 21.25C5.625 22.2913 7.70875 24.375 8.75 24.375C7.70875 24.375 5.625 26.4587 5.625 27.5C5.625 26.4587 3.54125 24.375 2.5 24.375ZM20 6.25C21.25 6.25 23.75 3.75 23.75 2.5C23.75 3.75 26.25 6.25 27.5 6.25C26.25 6.25 23.75 8.75 23.75 10C23.75 8.75 21.25 6.25 20 6.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.131e1f6884b868a668f62fa41d0e32cf.svg";
export { ForwardRef as ReactComponent };